import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../../../infrastructure/redux/store';

import {
  meses,
  gerar_grades_alocacoes,
  IAlocacao,
} from '../../../utils/generators/grade_alocaoes.generator';

import { LinhaAlocacao } from './linha_alocacao';
import { Body, Container, Header } from './styles';
import { IGradeAlocacao, selecionarAlocacao } from '../../../reducers/alocacao.reducer';

interface Props {
  data: IGradeAlocacao;
}

const AlocacoesCalendario: React.FC<Props> = (props) => {
  const { ocultar_dias, cores_professores } = useSelector((state: RootState) => state.alocacao);
  const [gradeAlocacoes, setGradeAlocacoes] = React.useState<IAlocacao[][]>();

  const dispatch = useDispatch();

  useEffect(() => {
    gerar_grades_alocacoes({
      ...props.data,
      ocultar_dias,
      cores_professores,
    }).then((grade) => {
      setGradeAlocacoes(grade);
    });
  }, [cores_professores, ocultar_dias, props.data.alocacoes]);

  const selecionar_alocacao = (alocacao: IAlocacao) => {
    dispatch(
      selecionarAlocacao({
        id_oferta: props.data.id_oferta,
        id_turma: props.data.id_turma,
        alocacao: alocacao,
      })
    );
  };

  return (
    <>
      {gradeAlocacoes?.map((alocacoes, numero_mes) => (
        <Container key={numero_mes}>
          <Header>
            <tr>
              <th colSpan={5}>{meses[numero_mes]}</th>
            </tr>

            <tr>
              <th>#</th>
              <th>Dia</th>
              <th>DiaS</th>
              <th>Aula</th>
              <th>Prof</th>
            </tr>
          </Header>

          <Body fechado>
            {alocacoes.map((alocacao) => (
              <LinhaAlocacao
                key={`${numero_mes}-${alocacao.dia_numero}`}
                alocacao={alocacao}
                onSelect={selecionar_alocacao}
              />
            ))}
          </Body>
        </Container>
      ))}
    </>
  );
};

export { AlocacoesCalendario };
